export default __webpack_public_path__ + "assets/images/4d260fcb3b671e743d01550f0f0674f2.jpg";